module.exports = __webpack_public_path__ + "static/img/logo.085f4968.png";